import { ShareIos } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconShareIos12Line = createIcon(ShareIos, 12, "Line");
export const IconShareIos16Line = createIcon(ShareIos, 16, "Line");
export const IconShareIos20Line = createIcon(ShareIos, 20, "Line");
export const IconShareIos24Line = createIcon(ShareIos, 24, "Line");
export const IconShareIos32Line = createIcon(ShareIos, 32, "Line");
export const IconShareIos48Line = createIcon(ShareIos, 48, "Line");
export const IconShareIos64Line = createIcon(ShareIos, 64, "Line");
